import { SxProps, Theme } from '@mui/material';
import React from 'react';
import { isDarkMode } from '../../theme';
import { IconButton } from './iconButton';

type ButtonType = 'edit' | 'add';

interface ActionIconButtonProps {
  readonly type?: ButtonType;
  readonly size: keyof typeof iconButtonSizes;
  readonly sx?: SxProps<Theme>;
  readonly onClick: () => void;
}

const iconButtonSizes = {
  s: { width: 24, height: 24, iconSize: 14 },
  m: { width: 32, height: 32, iconSize: 15 }
};

export function ActionIconButton({
  type = 'edit',
  size = 's',
  sx,
  ...props
}: ActionIconButtonProps) {
  const sizeStyles = {
    width: iconButtonSizes[size].width,
    height: iconButtonSizes[size].height,
    padding: 0,
    backgroundColor: isDarkMode() ? '#3C3C46' : '#EDEDF2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: isDarkMode() ? '#3C3C46' : '#EDEDF2'
    },
    '&:active': {
      backgroundColor: isDarkMode() ? '#3C3C46' : '#EDEDF2'
    },
    '&:focus': {
      backgroundColor: isDarkMode() ? '#3C3C46' : '#EDEDF2'
    }
  };

  const mergedStyles = { ...sx, ...sizeStyles };

  return (
    <IconButton
      {...props}
      icon={type === 'edit' ? 'edit' : 'add'}
      variant="primary"
      sx={mergedStyles}
    />
  );
}
